/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_cj_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convert CSV ↔ JSON`)
};

const es_cj_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convierte CSV ↔ JSON`)
};

const de_cj_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CSV ↔ JSON konvertieren`)
};

const nl_cj_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CSV ↔ JSON converteren`)
};

const fr_cj_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convertir CSV ↔ JSON`)
};

const it_cj_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Converti CSV ↔ JSON`)
};

const pt_br2_cj_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Converter CSV ↔ JSON`)
};

const pt_cj_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Converter CSV ↔ JSON`)
};

const ja_cj_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CSV ↔ JSON を変換`)
};

const zh_cj_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在 CSV 与 JSON 之间转换`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const cj_nav_main_desc = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cj_nav_main_desc(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("cj_nav_main_desc", locale)
	if (locale === "en") return en_cj_nav_main_desc(inputs)
	if (locale === "es") return es_cj_nav_main_desc(inputs)
	if (locale === "de") return de_cj_nav_main_desc(inputs)
	if (locale === "nl") return nl_cj_nav_main_desc(inputs)
	if (locale === "fr") return fr_cj_nav_main_desc(inputs)
	if (locale === "it") return it_cj_nav_main_desc(inputs)
	if (locale === "pt-BR") return pt_br2_cj_nav_main_desc(inputs)
	if (locale === "pt") return pt_cj_nav_main_desc(inputs)
	if (locale === "ja") return ja_cj_nav_main_desc(inputs)
	return zh_cj_nav_main_desc(inputs)
};